import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { api } from './api';
import AuthCard from './AuthCard';

const ResetPassword = ({ location }) => {
  const token = new URLSearchParams(location.search).get('t') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords don't match.");
    setError('');
    setLoading(true);
    try {
      await api('reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthCard title="Password updated">
        <Alert variant="success">Your password has been changed. You can log in with it now.</Alert>
        <Link to="/login" className="btn btn-primary btn-block">Log in</Link>
      </AuthCard>
    );
  }

  if (!token) {
    return (
      <AuthCard title="Reset your password">
        <Alert variant="danger">This reset link is incomplete. Request a new one.</Alert>
        <div className="text-center"><Link to="/forgot">Send a new link</Link></div>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Choose a new password">
      <Form onSubmit={submit}>
        {error && (
          <Alert variant="danger">
            {error} {/invalid|expired/.test(error) && <Link to="/forgot">Send a new link</Link>}
          </Alert>
        )}
        <Form.Group controlId="password">
          <Form.Label>New password</Form.Label>
          <Form.Control autoFocus type={showPassword ? 'text' : 'password'} autoComplete="new-password"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          <Form.Text className="text-muted">At least 8 characters.</Form.Text>
        </Form.Group>
        <Form.Group controlId="confirm">
          <Form.Label>Confirm password</Form.Label>
          <Form.Control type={showPassword ? 'text' : 'password'} autoComplete="new-password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <Form.Check className="mt-2" type="checkbox" label="Show passwords"
            checked={showPassword} onChange={(e) => setShowPassword(e.target.checked)} />
        </Form.Group>
        <Button type="submit" block disabled={loading}>
          {loading ? 'Saving…' : 'Change password'}
        </Button>
      </Form>
    </AuthCard>
  );
};

export default ResetPassword;
